import { render } from "./App.vue?vue&type=template&id=6bcd2631"
const script = {}
script.render = render

export default script